import { TOP_SIDE, BOTTOM_SIDE, COMBINED, TWO_SIDES } from "./StencilsConstants";

const sides = [
  { key: TOP_SIDE, label: 'Top only' },
  { key: BOTTOM_SIDE, label: 'Bottom only' },
  { key: COMBINED, label: 'Combine top and bottom' },
  { key: TWO_SIDES, label: 'Two Stencils top and bottom' },
]

export default sides;